import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import cn from 'classnames';
import _get from 'lodash/get';
import _startsWith from 'lodash/startsWith';
import styles from './index.module.scss';

import { AuthContext } from 'context/AuthContext';
import { useAppContext } from 'utils/hooks';
import rrLogo from 'assets/img/brand/rr-logo.svg';
import ssrReturnsLogo from 'assets/img/brand/ss-returns-logo.svg';
import trackingRabbitAppLogo from 'assets/img/brand/tracking-rabbit-logo.png';

export default function Logo({ className = '' }) {
  const { pathname } = useLocation();

  const { isSSRMode, appName } = useAppContext();
  const { appType, roles } = useContext(AuthContext);

  const isTrackingApp = _get(appType, 'shipmentTracking', 'false');
  const hasWarehouseAccess = _get(roles, 'warehouse', false);
  const hasStoreAccess = _get(roles, 'store', false);

  const isWarehouseRoute = pathname === '/w' || _startsWith(pathname, '/w/');
  const isStoreRoute = pathname === '/s' || _startsWith(pathname, '/s/');

  const linkTo =
    hasWarehouseAccess && isWarehouseRoute
      ? '/w'
      : hasStoreAccess && isStoreRoute
      ? '/s'
      : '/';
  const src = isTrackingApp
    ? trackingRabbitAppLogo
    : isSSRMode
    ? ssrReturnsLogo
    : rrLogo;

  return (
    <div className={cn(styles.container, className)}>
      <Link to={linkTo}>
        <img src={src} alt={appName} className={styles.logo} />
      </Link>
    </div>
  );
}
